module.exports = __webpack_public_path__ + "img/collection-weddingRingsNaturalBeige.4173bed.webp";